import {Box, Stack, css, styled} from '@mui/material';
import {StyledProps} from './types';

const ContentStack = styled(Stack)<StyledProps>`
	padding: 16px;

	${({theme}) => theme.breakpoints.between('sm', 'md')} {
		padding: 32px 120px;
	}

	${({theme}) => theme.breakpoints.up('md')} {
		padding: 32px 32px 16px;
	}

	${({$privateFlow}) =>
		$privateFlow &&
		css`
			&.MuiStack-root {
				padding: 0;
			}
		`}
`;

const ResendTokenButtonContainer = styled(Box)<StyledProps>`
	width: 100%;

	${({theme}) => theme.breakpoints.down('md')} {
		border-top: 1px solid ${({theme}) => theme.palette.other.outlineBorder};
		background-color: ${({theme}) => theme.palette.background.paper};
		padding: 8px 16px;
		position: fixed;
		bottom: 0;
		left: 0;
		right: 0;
		z-index: 3;
	}

	${({theme}) => theme.breakpoints.between('sm', 'md')} {
		padding-inline: 120px;
	}

	${({$privateFlow}) =>
		$privateFlow &&
		css`
			padding: 0;
		`}
`;

export {ContentStack, ResendTokenButtonContainer};
